<template>
  <div class="container">
    <div class="section">
      <div class="columns is-multiline is-centered">
        <div class="column is-12">
          <div class="columns is-vcentered is-mobile">
            <div class="column is-narrow">
              <title-bar badge="Beta" title="Contenido Web" />
            </div>
            <div class="column has-text-right">
              <button
                class="button is-intelligential"
                @click="emitAddEvent"
                v-if="['admin', 'developer', 'manager', 'compliance'].includes(role.code)"
              >
                Agregar
              </button>
            </div>
          </div>
          <div class="is-flex title-actions" style="justify-content: space-between; align-items: center;">
            <div class="tabs tabs-v3 is-small">
              <ul slot="content-actions">
                <li :class="{ 'active-customer': $route.name === 'pages' }">
                  <router-link :to="{ name: 'profile-pages' }">
                    Páginas
                  </router-link>
                </li>
                <li :class="{ 'active-customer': $route.name === 'widgets' }">
                  <router-link :to="{ name: 'profile-widgets' }">
                    Widgets
                  </router-link>
                </li>
                <hr />
              </ul>
            </div>
          </div>
        </div>
        <div class="column is-12">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import mixins from '@/mixins/formats'

export default {
  components: {
    TitleBar: () => import('@/components/ui/TitleBar.vue')
  },
  mixins: [mixins],
  computed: {
    ...mapState({
      systemConfiguration: state => state.configuration,
      profile: (state) => state.financialCompany.financialCompany,
      role: state => state.financialCompany.role
    })
  },
  methods: {
    emitAddEvent () {
      this.$root.$emit('open-add-modal')
    }
  }
}
</script>

<style lang="scss" scoped>
.section {
  padding-top: 1rem;
  padding-left: 1rem;
  padding-right: 1rem;
}
.tabs ul {
  border-bottom: 1px solid #dbdbdb;
  align-items: flex-end;
  font-size: 11px;
}
.active-customer {
  background: var(--blue-background);
  border-radius: 5px 5px 0 0;
  color: #50372e;
  font-weight: 600;
}
</style>
